import { render } from "./StudentAssignedExamView.vue?vue&type=template&id=6782c773&scoped=true"
import script from "./StudentAssignedExamView.vue?vue&type=script&lang=js"
export * from "./StudentAssignedExamView.vue?vue&type=script&lang=js"

import "./StudentAssignedExamView.vue?vue&type=style&index=0&id=6782c773&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6782c773"]])

export default __exports__